if (!customElements.get("search-suggestion")) {
    class SearchSuggestion extends HTMLElement {
        constructor() {
            super();
            this.recentlyViewed = null;
        }
        connectedCallback() {
            this.recentlyViewed = this.querySelector(".recently-viewed");
            this.firstCollection = this.querySelector(
                "nav [data-tab-list] button.active",
            );
            if (this.firstCollection) {
                const panelFor = this.firstCollection.getAttribute("panel-for");
                const panel = this.querySelector(`#${panelFor}`);
                if (panel) this.loadTabContent(panel);
            }
            this.addEventListeners();
        }

        addEventListeners() {
            this.tabButtons.forEach((button) => {
                if (window.matchMedia('(hover: hover)').matches) {
                    button.addEventListener("mouseenter", (e) => {
                        e.preventDefault();
                        this.hadleTabToggle(e);
                    });
                }

                button.addEventListener("click", (e) => {
                    e.preventDefault();
                    this.hadleTabToggle(e);
                });
            });
        }

        async loadTabContent(panel) {
            if (!panel.querySelector('[data-needs-load="true"]')) return;

            const collectionHandle = panel.dataset.collectionHandle;
            if (!collectionHandle) return;

            try {
                panel.setAttribute("aria-busy", "true");
                const response = await fetch(
                    `/collections/${collectionHandle}?section_id=search-tab-products&view=products-only`,
                );
                const html = await response.text();

                const tempDiv = document.createElement("div");
                tempDiv.innerHTML = html;
                const content = tempDiv.querySelector(".tab-products-content");

                if (content) {
                    panel.innerHTML = content.innerHTML;
                }
            } catch (error) {
                console.error("Tab content load error:", error);

                const placeholder = panel.querySelector(
                    ".tab-loading-placeholder",
                );
                if (placeholder) {
                    placeholder.innerHTML =
                        "<p>Content could not be loaded. Please try again.</p>";
                }
            } finally {
                panel.setAttribute("aria-busy", "false");
            }
        }

        hadleTabToggle(e) {
            if (
                e.currentTarget.classList.contains("active") ||
                e.currentTarget.getAttribute("data-has-collection") !== "true"
            )
                return;
            this.tabContents.forEach((content) => {
                content.removeAttribute("open", "");
                content.hidden = true;
            });
            this.tabButtons.forEach((button) => {
                button.classList.remove("active");
                button.setAttribute("aria-selected", "false");
            });
            const panelFor = e?.currentTarget.getAttribute("panel-for");
            const selectedPanel = this.querySelector(`#${panelFor}`);
            e.currentTarget.classList.add("active");
            e.currentTarget.setAttribute("aria-selected", "true");
            if (selectedPanel) {
                selectedPanel.setAttribute("open", "");
                selectedPanel.hidden = false;
                this.loadTabContent(selectedPanel);
            }
            if (this.recentlyViewed) {
                if (this.recentlyViewed.hidden === false)
                    this.recentlyViewed.hidden = true;
            }
        }

        get tabContents() {
            return this.querySelectorAll("[tab-panel]");
        }

        get tabButtons() {
            return this.querySelectorAll("[tab-button]");
        }
    }

    customElements.define("search-suggestion", SearchSuggestion);
}
